<template>
  <div class="ts-overflow-hidden">
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-2 form-group ts-px-2 ts-pt-6 ts-space-x-2">
            <div class="ts-flex ts-justify-between">
              <div class="ts-justify-start">
                <ts-button
                  v-if="isStaff || isTeacher"
                  class="ts-mb-1"
                  color="info"
                  outline
                  @click.prevent="() => (show_form = true)"
                  >{{ $t('add_new') }}
                </ts-button>
              </div>
              <div class="ts-justify-end">
                <label class="ts-mt-3">{{
                  $t('studentGallery.eventDate')
                }}</label>
              </div>
            </div>
          </div>
          <div class="col-md-2 form-group ts-px-2">
            <label class="form-col-label control-label required ts-mb-2">{{
              $t('studentGallery.dateFrom')
            }}</label>
            <ts-date-picker-input
              :class="{ 'is-invalid': errors.has('date_from') }"
              v-model="date_from"
            ></ts-date-picker-input>
            <div
              class="ivu-form-item-error ts-text-red-600"
              v-if="errors.has('date_from')"
            >
              {{ errors.first('date_from') }}
            </div>
          </div>
          <div class="col-md-2 form-group ts-px-2">
            <label class="form-col-label control-label required ts-mb-2">{{
              $t('studentGallery.dateTo')
            }}</label>
            <ts-date-picker-input
              :class="{ 'is-invalid': errors.has('date_to') }"
              v-model="date_to"
            ></ts-date-picker-input>
            <div
              class="ivu-form-item-error ts-text-red-600"
              v-if="errors.has('date_to')"
            >
              {{ errors.first('date_to') }}
            </div>
          </div>
          <div class="col-md-3 form-group ts-px-2"></div>
          <div class="col-md-3 form-group ts-px-2">
            <label class="form-col-label control-label ts-mb-2"></label>
            <ts-input
              v-model="search"
              :placeholder="$t('studentGallery.search')"
            />
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
    <ts-loading-banner :loading="loading">
      <div
        style="height: 75vh;"
        class="ts-overflow-y-auto ts-overflow-x-hidden ts-mt-4 drive-wrapper drive-grid-view ts-rounded-md"
      >
        <div v-if="isHasPhoto">
          <div
            class="tab-pane fade show active grid-items-wrapper"
            v-for="(items, date) in resources"
            :key="date"
          >
            <h2
              class="m-t-5 m-b-5 ts-sticky ts-top-0 ts-z-10 ts-p-2 ts-opacity-90 ts-font-bold ts-font-sans ts-text-sm ts-flex ts-justify-between"
              style="text-shadow: 0 0 3px #fff, 0 0 5px #fff;background: #f5f5f5;"
            >
              <div class="ts-flex ts-justify-start">
                {{ date }}
              </div>
              <div class="ts-flex ts-justify-end text-danger">
                <a-popconfirm
                  v-if="isStaff || isTeacher"
                  placement="leftTop"
                  :title="$t('are_you_sure_to_delete')"
                  :ok-text="$t('yes')"
                  :cancel-text="$t('no')"
                  @confirm="deleteRecord(items[0].upload_id)"
                >
                  <a href="#">
                    <i class="fas fa-trash"></i>
                  </a>
                </a-popconfirm>
              </div>
            </h2>

            <div class="row row-space-2" v-viewer>
              <div
                class="col-lg-1 col-sm-2 col-3"
                v-for="(item, index) in items"
                :key="index"
              >
                <a
                  class="widget-card square m-b-2 photo-wrapper"
                  @contextmenu.prevent="onRightClick($event, item)"
                >
                  <img
                    class="widget-card-cover"
                    v-lazy="{
                      src: photo(item),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                  <!-- @click="imageView(index, items)" -->
                </a>
              </div>
            </div>
          </div>
        </div>
        <div v-else style="margin: auto; width: 300px; margin-top:150px">
          <img :src="require('@/assets/cover-scrum-board.png')" />
          <h1 class="text-center ts-text-4xl ts-font-bold ts-opacity-25">
            No Photo
          </h1>
        </div>
        <vue-context ref="menu">
          <li v-for="(m, i) in menus" :key="i">
            <a href="#" @click.prevent="handle_function_call(m.action_name)"
              ><i class="ts-mr-3" :class="m.icon"></i> {{ m.name }}</a
            >
          </li>
        </vue-context>
      </div>
    </ts-loading-banner>
    <!-- form action -->
    <a-modal
      v-model="show_form"
      :title="$t('studentGallery.pageTitle')"
      :zIndex="1020"
      :footer="null"
      :maskClosable="false"
      width="45%"
      @cancel="clearInput"
    >
      <form-component
        ref="form_component"
        @close="() => (show_form = false)"
        @fetchData="fetchData"
      />
    </a-modal>
    <a-drawer
      :title="$t('studentGallery.info')"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      :zIndex="1020"
      width="300px"
    >
      <info :photoItem="model" />
    </a-drawer>
  </div>
</template>

<script>
import VueContext from 'vue-context'
import { Errors } from 'form-backend-validation'
import Vue from 'vue'
import FormComponent from './form'
import { isEmpty, debounce } from 'lodash'
import info from './components/info'
import * as FileDownload from 'downloadjs'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer)

export default {
  name: 'studentGallery',
  components: { FormComponent, VueContext, info },
  data () {
    return {
      errors: new Errors(),
      loading: false,
      show_form: false,
      visible: false,
      model: {},
      images: [],
      resources: {},
      menus: [
        {
          name: 'Download',
          action_name: 'download',
          icon: 'fas fa-download'
        },
        {
          name: 'Delete',
          action_name: 'delete',
          icon: 'fas fa-trash'
        },
        {
          name: 'Info',
          action_name: 'info',
          icon: 'fas fa-info-circle'
        }
      ]
    }
  },
  computed: {
    countItems: () => items => {
      return Object.values(items).length
    },
    isHasPhoto () {
      return !isEmpty(this.resources)
    },
    isStaff () {
      return this.$store.getters.isStaffLogin
    },
    isTeacher () {
      return this.$store.getters.isTeacherLogin
    },
    search: {
      get () {
        return this.$store.state.staffStudentGallery.search
      },
      set (val) {
        this.$store.commit('staffStudentGallery/SET_SEARCH', val)
      }
    },
    date_from: {
      get () {
        return this.$store.state.staffStudentGallery.date_from
      },
      set (val) {
        this.$store.commit('staffStudentGallery/SET_DATE_FROM', val)
      }
    },
    date_to: {
      get () {
        return this.$store.state.staffStudentGallery.date_to
      },
      set (val) {
        this.$store.commit('staffStudentGallery/SET_DATE_TO', val)
      }
    }
  },
  methods: {
    photo (record) {
      if (record.file_path) {
        return record.file_path
      }
      return require('@/assets/default_user.jpg')
    },
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('staffStudentGallery/fetch', attributes)
        .then(response => {
          this.resources = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput () {
      this.$refs.form_component.clearInput()
    },
    onRightClick (e, item) {
      this.$refs.menu.open(e, item)
      this.model = item
    },
    handle_function_call (function_name) {
      this[function_name]()
    },
    async delete () {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.loading = true
        this.$store
          .dispatch('staffStudentGallery/removePhoto', this.model.id)
          .then(response => {
            this.loading = false
            this.fetchData()
            if (response.message_id == -1) {
              this.$toasted.info(response.message)
            } else {
              this.$toasted.success(response.message)
            }
          })
          .catch(error => {
            this.loading = false
            this.$toasted.error(error.message)
          })
      }
    },
    deleteRecord (upload_id) {
      this.loading = true
      this.$store
        .dispatch('staffStudentGallery/destroy', upload_id)
        .then(response => {
          this.loading = false
          this.fetchData()
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    download () {
      FileDownload(this.model.file_path)
    },
    info () {
      this.visible = true
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('staffStudentGallery/RESET_STATE')
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  watch: {
    search: debounce(function () {
      this.fetchData()
    }, 500),
    date_from: function () {
      this.fetchData()
    },
    date_to: function () {
      this.fetchData()
    }
  }
}
</script>
<style scoped lang="scss">
.drive-wrapper {
  padding-top: 0 !important;
  background: #f5f5f5;
}
.photo-wrapper {
  background: #fff;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.photo-wrapper:hover img {
  padding: 5px;
  opacity: 0.8;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
}
</style>
